import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import Menu from './Menu';
import Settings from './Setting';
import Common from './Common';
import DataKeluarga from './DataKeluarga';
import FilterPegawai from './Filter';
import Dashboard from './Dashboard';
import Laporan from './Laporan';
import LaporanJabfung from './LaporanJabfung';
import DRH from './DRH';
import UploadBerkas from './UploadBerkas';
import Grafik from './Grafik';
import DataPegawai from './DataPegawai';
import LaporanKhusus from './LaporanKhusus';
import MasterData from './Masterdata';
import Manajemen from './Manajemen';
import Logbook from './LogBook';
import Pengaturan from './Pengaturan';
import Monitoring from './Monitoring';
import SLKS from './SLKS';
import ProgramKerja from './ProgramKerja';
import Presensi from './Presensi';
import UmpanBalik360 from './UmpanBalik360';

const reducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    menuApp: Menu,
    common: Common,
    settings: Settings,
    filters: FilterPegawai,
    dashboard: Dashboard,
    dataKeluarga: DataKeluarga,
    uploadBerkas: UploadBerkas,
    laporan: Laporan,
    laporanJabfung: LaporanJabfung,
    drh: DRH,
    grafik: Grafik,
    dataPegawai: DataPegawai,
    laporanKhusus: LaporanKhusus,
    masterData: MasterData,
    manajemen: Manajemen,
    logbook: Logbook,
    pengaturan: Pengaturan,
    monitoring: Monitoring,
    slks: SLKS,
    programKerja: ProgramKerja,
    presensi: Presensi,
    umpanBalik360: UmpanBalik360,
  });
export default reducers;
